import React from 'react';

export type Toast = {
  message: string | React.ReactNode;
  actionButtonText?: string
  actionButtonOnClick?: () => void;
  permanent?: boolean,
  logMessage?: string,
  code?: string,
  isUserError?: boolean,
  tealiumError?: string | null,
  suppressTealiumEvent?: boolean,
  messageSubtitle?: string | null,
  type?: string;
  position?: 'top' | 'bottom',
  className?: string,
}

class ToastMessageService {
  private addMethod?: (toast: Toast) => void | null;
  private removeAll?: Function | null;

  setAddMethod(addMethod?: (toast: Toast) => void) {
    this.addMethod = addMethod;
  }

  setRemoveAllMethod(removeAllMethod?: Function) {
    this.removeAll = removeAllMethod;
  }

  addToast(toast: Toast) {
    if (this.addMethod && typeof this.addMethod === 'function') {
      this.addMethod(toast);
    }
  }

  removeAllToasts() {
    if (this.removeAll && typeof this.removeAll === 'function') {
      this.removeAll();
    }
  }

  addError(
    message?: string,
    logMessage?: string | null,
    code: string = 'N/A',
    isUserError = false,
    tealiumError?: null,
    suppressTealiumEvent = false,
    messageSubtitle?: null,
  ) {
    if (logMessage) {
      console.error(logMessage);
    }
    const toast = {
      message: message,
      type: 'ERROR',
      errorCode: code,
      isUserError: isUserError,
      tealiumError: tealiumError,
      suppressTealiumEvent: suppressTealiumEvent,
      messageSubtitle: messageSubtitle,
    };
    this.addToast(toast);
  }
}

const toastMessageServiceSingleton = new ToastMessageService();

export default toastMessageServiceSingleton;
